export default[
    {
        path:'logistics',
        name:'logistics',
        component: resolve => require(['@/components/logistics/view/logistics.vue'], resolve),
        redirect:'/survey',
        children:[
            //概况
            {
                path: '/survey',
                name: 'survey',
                component:() => import("../components/logistics/survey/survey.vue")
            },
            //物流管理
            //入库管理
            {
                path: '/instockManage',
                name: 'instockManage',
                component:() => import("../components/logistics/deliverManage/instockManage/instockManage.vue")
            },
            //添加入库
            {
                path: '/addInstock',
                name: 'addInstock',
                component:() => import("../components/logistics/deliverManage/instockManage/addInstock.vue")
            },
            //修改入库
            {
                path: '/editInstock',
                name: 'editInstock',
                component:() => import("../components/logistics/deliverManage/instockManage/editInstock.vue")
            },
            //打印入库单
            {
                path: '/printInstock',
                name: 'printInstock',
                component:() => import("../components/logistics/deliverManage/instockManage/printInstock.vue")
            },
            //发货管理
            {
                path: '/deliverManage',
                name: 'deliverManage',
                component:() => import("../components/logistics/deliverManage/deliverManage/deliverManage.vue")
            },
            //添加发货
            {
                path: '/addDeliver',
                name: 'addDeliver',
                component:() => import("../components/logistics/deliverManage/deliverManage/addDeliver.vue")
            },
            //修改发货
            {
                path: '/editDeliver',
                name: 'editDeliver',
                component:() => import("../components/logistics/deliverManage/deliverManage/editDeliver.vue")
            },
            //发货打印
            {
                path: '/printDeliver',
                name: 'printDeliver',
                component:() => import("../components/logistics/deliverManage/deliverManage/printDeliver.vue")
            },
            //退货管理
            {
                path: '/refundManage',
                name: 'refundManage',
                component:() => import("../components/logistics/deliverManage/refundManage/refundManage.vue")
            },
            //打印退货单
            {
                path: '/printRefund',
                name: 'printRefund',
                component:() => import("../components/logistics/deliverManage/refundManage/printRefund.vue")
            },
           
            {
                // retailManage  零售管理
                path: '/retailManage',
                name: 'retailManage',
                component:() => import("../components/logistics/deliverManage/retailManage/retailManage.vue")
            },
             { 
                // requisitionManage  商品调拨
                path: '/requisitionManage',
                name: 'requisitionManage',
                component:() => import("../components/logistics/deliverManage/requisitionManage/requisitionManage.vue")
            },
            {
                // 新建商品调拨单 addrequisition
                path: '/addrequisition',
                name: 'addrequisition',
                component:() => import("../components/logistics/deliverManage/requisitionManage/addrequisition.vue")
                
            },
            { 
                // requisitionManage  调仓管理
                path: '/ware',
                name: 'ware',
                component:() => import("../components/logistics/deliverManage/ware/ware.vue")

            },
            {
                // addWareOrder   新建调拨仓订单
                path: '/addWareOrder',
                name: 'addWareOrder',
                component:() => import("../components/logistics/deliverManage/ware/addWareOrder.vue")
            },
            //追踪查询
            {
                path: '/traceManage',
                name: 'traceManage',
                component:() => import("../components/logistics/deliverManage/traceManage/traceManage.vue")
            },
            //在线订单管理
            //商品上架管理
            {
                path: '/goodsOnput',
                name: 'goodsOnput',
                component:() => import("../components/logistics/ordersmanagement/goodsOnput/goodsOnput.vue")
            },
            //通用商品上架
            {
                path: '/generalOnput',
                name: 'generalOnput',
                component:() => import("../components/logistics/ordersmanagement/goodsOnput/generalOnput.vue")
            },
            {
                // 客户指定商品上架 customerOnput
                path: '/specifyOnput',
                name: 'specifyOnput',
                component:() => import("../components/logistics/ordersmanagement/goodsOnput/specifyOnput.vue")
            },
            //经销商订单管理
            {
                // dealerOrder
                path: '/dealerOrder',
                name: 'dealerOrder',
                component:() => import("../components/logistics/ordersmanagement/dealerOrder/dealerOrder.vue")
            },
              //经销商订单详情
              {
                // dealerOrder
                path: '/dealerOrderDetail',
                name: 'dealerOrderDetail',
                component:() => import("../components/logistics/ordersmanagement/dealerOrder/dealerOrderDetail.vue")
            },
              //经销商订单审核  
              {
                // dealerOrder
                path: '/dealeOrderReview',
                name: 'dealeOrderReview',
                component:() => import("../components/logistics/ordersmanagement/dealerOrder/dealeOrderReview.vue")
            },
            //经销商订单 - 发货单保存 
            {
                // dealerOrder
                path: '/dealerOrderSave',
                name: 'dealerOrderSave',
                component:() => import("../components/logistics/ordersmanagement/dealerOrder/dealerOrderSave.vue")
            },
            //门店订单管理
            {
                // storOrder
                path: '/storeOrder',
                name: 'storeOrder',
                component:() => import("../components/logistics/ordersmanagement/storeOrder/storeOrder.vue")
            }
            ,
              //门店订单详情
              {
                // storeOrderDetail
                path: '/storeOrderDetail',
                name: 'storeOrderDetail',
                component:() => import("../components/logistics/ordersmanagement/storeOrder/storeOrderDetail.vue")
            },
              //门店订单审核  
              {
                // store
                path: '/storeOrderReview',
                name: 'storeOrderReview',
                component:() => import("../components/logistics/ordersmanagement/storeOrder/storeOrderReview.vue")
            },
            // 返利管理
            {
                path: '/backManagement',
                name: 'backManagement',
                component:() => import("../components/logistics/back/backManagement/backManagement.vue")
            },
             // 经销余额明细
             {
                path: '/backDetail',
                name: 'backDetail',
                component:() => import("../components/logistics/back/backDetail/backDetail.vue")
            },
             // 返利历史记录
             {
                path: '/backHistory',
                name: 'backHistory',
                component:() => import("../components/logistics/back/backHistory/backHistory.vue")
             },
            //返利管理
            //返利发放记录
            {
                path: '/rebateIssue',
                name: 'rebateIssue',
                component:() => import("../components/logistics/rebateManage/rebateIssue/rebateIssue.vue")
            },
            //经销商返利管理
            {
                path: '/rebateManage',
                name: 'rebateManage',
                component:() => import("../components/logistics/rebateManage/rebateManage/rebateManage.vue")
            },
            //经销商余额明细
            {
                path: '/touchBalance',
                name: 'touchBalance',
                component:() => import("../components/logistics/rebateManage/touchBalance/touchBalance.vue")
            },
            //报表管理
            //总部库存统计
            {
                path: '/baseCount',
                name: 'baseCount',
                component:() => import("../components/logistics/statementManage/baseCount/baseCount.vue")
            },
            //经销️窜货统计
            {
                path: '/fleeingCount',
                name: 'fleeingCount',
                component:() => import("../components/logistics/statementManage/fleeingCount/fleeingCount.vue")
            },
            // 经销商库存管理
            {
                // Dealerstock
                path: '/Dealerstock',
                name: 'Dealerstock',
                component:() => import("../components/logistics/statementManage/Dealerstock/Dealerstock.vue")
            },
            // 门店库存统计
            {
                // storeCount
                path: '/storeCount',
                name: 'storeCount',
                component:() => import("../components/logistics/statementManage/storeCount/storeCount.vue")
            },
            // 盘点统计
            {
                // inventoryCount 
                path: '/inventoryCount',
                name: 'inventoryCount',
                component:() => import("../components/logistics/statementManage/inventoryCount/inventoryCount.vue")
            },
            // 产品周转率统计
            {
                // turnCount
                path: '/turnCount',
                name: 'turnCount',
                component:() => import("../components/logistics/statementManage/turnCount/turnCount.vue")
            },
            //基础管理
            //基础设置
            {
                path: '/basicSetting',
                name: 'basicSetting',
                component:() => import("../components/logistics/basicManage/basicSetting/basicSetting.vue")
            },
            //仓库设置
            {
                path: '/instockSetting',
                name: 'instockSetting',
                component:() => import("../components/logistics/basicManage/stockSetting/instockSetting.vue")
            },
            //添加/编辑仓库
            {
                path: '/addStock',
                name: 'addStock',
                component:() => import("../components/logistics/basicManage/stockSetting/addStock.vue")
            },
        ]
    }
]